import React from 'react';
import { bool, object, string, func } from 'prop-types';
import PaymentMethod from './PaymentMethod';
import PaymentLinkSent from './PaymentLinkSent';

function Payment(props) {
  let { error, quote = null, isLinkSent, clearPaymentLinkSent } = props;
  if (isLinkSent) {
    return <PaymentLinkSent onClose={clearPaymentLinkSent} />;
  }
  return <PaymentMethod quote={quote} error={error} />;
}

Payment.propTypes = {
  error: string,
  quote: object,
  isLinkSent: bool,
  clearPaymentLinkSent: func,
};

export default Payment;



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/PaymentPage.js